namespace Portico.Directives {

	import pm = Portico.Models;
	import pme = Portico.Models.Enterprise;
	import pmi = Portico.Models.Interfaces;
	import pms = Portico.Models.Setup;
	import ps = Portico.Services;

	export interface ITcPdfHtmlController {
		clazz: string;
		label: string;
		template: string;
		styles: string;
		filename: string;
		submit(): any;
	}

	export class TcPdfHtmlController implements ITcPdfHtmlController {
		clazz: string;
		label: string;
		template: string;
		styles: string;
		filename: string;

		constructor(
			private $compile: angular.ICompileService,
			private $http: angular.IHttpService,
			private $scope: angular.IScope,
			private $timeout: angular.ITimeoutService,
			private dataService: ps.IDataService,
			private serverConstants: pmi.IServerConstants
		) { }

		submit() {
			const temp = this.dataService.getDataValue('Component', 'Html', this.template);
			const element = this.$compile(temp)(this.$scope);

			this.$timeout(() => {
				const html = element.html();
				const css = this.dataService.getDataValue('Style', 'CSS', this.styles);
				const name = this.filename ? `${this.filename}.pdf` : 'output.pdf';
				this.$http.post(`${this.serverConstants.pdfPath}/html`, {
					pdfRequest: {
						fileName: name,
						template: html,
						pdfContents: [{
							content: css
						}]
					}
				}, {
					responseType: 'arraybuffer'
				})
				.then(response => {
					var blob = new Blob([response.data as any	], { type: 'application/pdf' });
					if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
						window.navigator.msSaveOrOpenBlob(blob, name);
					} else { // for Non-IE (chrome, firefox etc.)
						var link = document.createElement('a');
						link.href = window.URL.createObjectURL(blob);
						link.download = name;
						link.click();
						link.remove();
					}
				})
				.catch(error => {
					console.log(error);
				});
			}, 0);
		}
	}

	angular.module('app').directive('tcPdfHtml', [() => {
		return {
			bindToController: {
				clazz: '@',
				label: '@',
				template: '@',
				styles: '@',
				filename: '@'
			},
			controller: ['$compile', '$http', '$scope', '$timeout', 'dataService', 'serverConstants', <any>TcPdfHtmlController],
			controllerAs: '$pdf',
			replace: true,
			require: ['tcPdfHtml'],
			restrict: 'E',
			scope: true,
			template: `<input class="{{$pdf.clazz}}" type="submit" ng-click="$pdf.submit()" value="{{$pdf.label}}" />`
		};
	}
	]);
}